import { useState, useEffect } from "react";
import HumanRiskIndex from "./HumanRiskIndex";
import AdminSimulator from "./components/AdminSimulator";
import * as FiIcons from 'react-icons/fi';
import SafeIcon from './common/SafeIcon';
import { T, SERIF } from "./lib/model";

const { FiShield, FiTrendingUp, FiSettings, FiArrowRight, FiTarget } = FiIcons;

export default function App() {
  const [view, setView] = useState("home");

  // Handle direct links to simulator if needed
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("view") === "simulator") setView("simulator");
  }, []);

  if (view === "assessment") {
    return <HumanRiskIndex onBackToHome={() => setView("home")} />;
  }

  if (view === "simulator") {
    return <AdminSimulator onBack={() => setView("home")} />;
  }

  return (
    <div className="min-h-screen bg-[#F2F6FA] flex flex-col font-sans selection:bg-teal-100">
      <main className="flex-1 flex flex-col items-center justify-center p-6 text-center">
        <div className="max-w-4xl w-full">
          <div className="flex justify-center mb-10">
            <img 
              src="https://media-manager-c.questera.ai/greta-media/ecb16a7902f793d76e4d541ba9ce1c3ae6d96976df461599e59c7024cc2713617bff44ec4f8cbf96d32b4bb87bd2d993/images/aW1hZ2UvcG5n/07cb85c4268f1317cf05349009b1d943.png" 
              alt="Logo" 
              className="h-16 w-auto"
            />
          </div>
          
          <h1 style={{ fontFamily: SERIF }} className="text-5xl md:text-7xl font-black text-[#0D2440] leading-tight tracking-tight">
            The Human Risk <span className="text-teal-500">Index</span>
          </h1>
          
          <p className="mt-8 text-xl text-gray-600 font-medium max-w-2xl mx-auto leading-relaxed">
            Quantify and manage the human layer of your cybersecurity posture with production-grade risk modeling.
          </p>

          <div className="mt-12 flex flex-col sm:flex-row gap-6 justify-center">
            <button
              onClick={() => setView("assessment")}
              style={{ background: T.ink }}
              className="px-10 py-5 rounded-2xl text-white font-black text-lg shadow-2xl hover:brightness-110 transition-all flex items-center justify-center gap-3 active:scale-95"
            >
              Start Risk Assessment
              <SafeIcon icon={FiArrowRight} className="w-5 h-5" />
            </button>
            
            <button
              onClick={() => setView("simulator")}
              className="px-10 py-5 rounded-2xl bg-white border-2 border-gray-100 text-[#0D2440] font-black text-lg hover:border-teal-500 hover:text-teal-600 transition-all flex items-center justify-center gap-3 active:scale-95"
            >
              <SafeIcon icon={FiSettings} className="w-5 h-5" />
              Engine Simulator
            </button>
          </div>

          <div className="mt-20 grid sm:grid-cols-3 gap-8 text-left">
            <div className="bg-white p-8 rounded-3xl shadow-sm border border-gray-100">
              <SafeIcon icon={FiShield} className="w-8 h-8 text-blue-500 mb-4" />
              <h3 className="font-black text-[#0D2440] mb-2">Exposure Scoring</h3>
              <p className="text-sm text-gray-500 font-bold">0-100 normalized risk exposure across 7 strategic domains.</p>
            </div>
            <div className="bg-white p-8 rounded-3xl shadow-sm border border-gray-100">
              <SafeIcon icon={FiTrendingUp} className="w-8 h-8 text-teal-500 mb-4" />
              <h3 className="font-black text-[#0D2440] mb-2">Maturity Modeling</h3>
              <p className="text-sm text-gray-500 font-bold">1-5 maturity ranking based on the lowest-material-capability principle.</p>
            </div>
            <div className="bg-white p-8 rounded-3xl shadow-sm border border-gray-100">
              <SafeIcon icon={FiTarget} className="w-8 h-8 text-lime-500 mb-4" />
              <h3 className="font-black text-[#0D2440] mb-2">Critical Overrides</h3>
              <p className="text-sm text-gray-500 font-bold">Intelligent logic that identifies non-negotiable security failures.</p>
            </div>
          </div>
        </div>
      </main>
      
      <footer className="py-10 text-center border-t border-gray-200">
        <p className="text-[10px] font-black uppercase text-gray-400 tracking-widest">
          Human Risk Index&trade; &middot; Power Plays by Eric Stavola &middot; Intelligent Provider Services
        </p>
      </footer>
    </div>
  );
}